export const padZerosLeft = (number: number | string, length: number) => {
    return String(number).padStart(length, '0');
}